export default __webpack_public_path__ + "static/media/Spotify1.39834089.png";